<div class="popBox">
  <div class="titleTop">
    <h5 class="popupTitle"></h5>
    <button
      class="btn normalDeleteBtn"
      (click)="closeModal()"
      [routerLink]="'/'"
    >
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="popBody">
    <div class="success-animation">
      <svg
        class="checkmark"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 52 52"
      >
        <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
        <path
          class="checkmark__check"
          fill="none"
          d="M14.1 27.2l7.1 7.2 16.7-16.8"
        />
      </svg>
    </div>

    <p class="msg">
      <strong>Congratulations!</strong>
      Your inventory has been successfully posted. It’s live now.
    </p>
    <div class="equalBtn">
      <button type="button" class="cancel-btn red">Edit</button>
      <button type="submit" class="submit-btn green">Preview</button>
    </div>
  </div>
</div>
